import { DonateModal } from 'components/Modal/DonateModal';
import ErrorBoundaryWrapper from 'components/ErrorBoundaryWrapper';
import { PausedModal } from 'components/Modal/PausedModal';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { MainContainer } from 'screens/Main/styled';
import Error from 'components/Error';
import { DesktopLeftContainer } from 'components/DesktopLeftContainer';
import { Body, H3 } from 'components/Typography';

interface Props {
  error?: string;
  shouldAlertOnError?: boolean;
  pausedMisc?: any;
  showLeftSide: boolean;
  showPausedModal: boolean;
  showDonateModal: boolean;
}

const DonateAndCheckoutLayout: FC<Props> = ({
  error,
  shouldAlertOnError = false,
  pausedMisc,
  showLeftSide,
  showPausedModal,
  showDonateModal,
}) => {
  if (error) {
    return (
      <MainContainer>
        <Error
          data={{ component: 'Main' }}
          errorMsg="API failure on donate page"
          shouldAlert={shouldAlertOnError}
        >
          <H3>{error}</H3>
        </Error>
      </MainContainer>
    );
  }

  return (
    <MainContainer>
      {showPausedModal && <PausedModal paused_misc={pausedMisc} />}
      {showDonateModal && <DonateModal />}
      {showLeftSide && <DesktopLeftContainer />}
      <ErrorBoundaryWrapper
        fallback={
          <Error
            data={{ component: 'Slate' }}
            errorMsg="Failure with donate Slate component"
            shouldAlert={true}
          >
            <Body>We encountered an error. Please contact support.</Body>
          </Error>
        }
      >
        <Outlet />
      </ErrorBoundaryWrapper>
    </MainContainer>
  );
};

export default DonateAndCheckoutLayout;
